import axios from 'axios';

export function getUserLocation() {
  return axios.get('https://ipapi.co/json/')
    .then(response => response.data)
    .catch(error => {
      console.error('Erro ao buscar a localização do usuário:', error);
      throw error;
    });
}